import A from './components/A';
import B from './components/B';
import css from './index.module.scss';

export default function Teaser() {
    return (
        <div className={`delta-2-max-teaser ${css.d2xTeaser}`}>
            <A />
            <B />
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
}
